export function shouldClearDuplicateReturnViewId(viewId: string) {
  return viewId !== "custom"
}

export function getRestoreViewIdOnMetricsSelectorClose(
  returnViewId: string | null,
  currentView: string,
) {
  if (returnViewId && currentView === "custom") {
    return returnViewId
  }

  return null
}
